const techLinks = {
  // Languages
  Python: 'https://www.python.org',
  JavaScript: 'https://developer.mozilla.org/docs/Web/JavaScript',
  TypeScript: 'https://www.typescriptlang.org',
  Java: 'https://www.java.com',
  JavaFX: 'https://openjfx.io',
  PHP: 'https://www.php.net',
  Go: 'https://go.dev',
  Rust: 'https://www.rust-lang.org',
  Ruby: 'https://www.ruby-lang.org',
  'C++': 'https://isocpp.org',
  'C#': 'https://learn.microsoft.com/dotnet/csharp',
  Kotlin: 'https://kotlinlang.org',
  Swift: 'https://www.swift.org',

  // Frameworks & Libraries
  FastAPI: 'https://fastapi.tiangolo.com',
  Flask: 'https://flask.palletsprojects.com',
  Django: 'https://www.djangoproject.com',
  React: 'https://react.dev',
  'React Native': 'https://reactnative.dev',
  'Next.js': 'https://nextjs.org',
  'Node.js': 'https://nodejs.org',
  'Vue.js': 'https://vuejs.org',
  Angular: 'https://angular.dev',
  'Spring Boot': 'https://spring.io/projects/spring-boot',
  'Spring Security': 'https://spring.io/projects/spring-security',
  Laravel: 'https://laravel.com',
  'Tailwind CSS': 'https://tailwindcss.com',
  LangChain: 'https://www.langchain.com',
  LangGraph: 'https://www.langchain.com/langgraph',
  TensorFlow: 'https://www.tensorflow.org',
  Keras: 'https://keras.io',
  'Scikit-learn': 'https://scikit-learn.org',
  PyTorch: 'https://pytorch.org',
  OpenCV: 'https://opencv.org',
  'Hugging Face': 'https://huggingface.co',
  Nginx: 'https://nginx.org',
  GraphQL: 'https://graphql.org',
  Streamlit: 'https://streamlit.io',
  Pandas: 'https://pandas.pydata.org',
  'Three.js': 'https://threejs.org',
  Gatsby: 'https://www.gatsbyjs.com',
  'Styled Components': 'https://styled-components.com',
  Pytest: 'https://docs.pytest.org',

  // AI & ML
  OpenAI: 'https://openai.com',
  Groq: 'https://groq.com',
  'Deep Learning': 'https://www.tensorflow.org',
  NLP: 'https://spacy.io',
  LSTM: 'https://www.tensorflow.org',
  SVM: 'https://scikit-learn.org',
  RAG: 'https://www.langchain.com',
  UNet: 'https://www.tensorflow.org',
  EfficientNetB4: 'https://www.tensorflow.org',
  'AI/ML': 'https://www.tensorflow.org',

  // Databases
  PostgreSQL: 'https://www.postgresql.org',
  MySQL: 'https://www.mysql.com',
  MongoDB: 'https://www.mongodb.com',
  Redis: 'https://redis.io',
  SQLite: 'https://www.sqlite.org',
  Supabase: 'https://supabase.com',
  pgvector: 'https://github.com/pgvector/pgvector',

  // DevOps / Cloud
  Docker: 'https://www.docker.com',
  Kubernetes: 'https://kubernetes.io',
  'GitHub Actions': 'https://docs.github.com/actions',
  Linux: 'https://www.linux.org',
  Git: 'https://git-scm.com',
  GitHub: 'https://github.com',
  AWS: 'https://aws.amazon.com',
  'Amazon Web Services (AWS)': 'https://aws.amazon.com',
  Azure: 'https://azure.microsoft.com',
  'Google Cloud': 'https://cloud.google.com',
  Vercel: 'https://vercel.com',
  Netlify: 'https://www.netlify.com',
  Prometheus: 'https://prometheus.io',

  // Other
  Oracle: 'https://www.oracle.com',
  Odoo: 'https://www.odoo.com',
  Cisco: 'https://www.cisco.com',
  NVIDIA: 'https://www.nvidia.com',
  'REST API': 'https://restfulapi.net',
  'Data Visualization': 'https://plotly.com',
  'Time Series': 'https://www.tensorflow.org',
  'Signal Processing': 'https://scipy.org',
  Mojo: 'https://www.modular.com/mojo',
};

export default techLinks;

